import { TooltipContent, Tooltip, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/utils/tailwind/utils";
import { HelpCircle, X } from "lucide-react";
import { FC, PropsWithChildren } from "react";

interface HelpTooltipProps {
  className?: string;
  title: JSX.Element;
  open: boolean;
  onClickOpen: () => void;
  onClickClose: () => void;
  position: "top" | "bottom" | "left" | "right";
  align: "start" | "center" | "end";
  alignOffset?: number;
}

export const HelpTooltip: FC<PropsWithChildren<HelpTooltipProps>> = (props) => {
  const { className, title, children, open, position, align, onClickClose, onClickOpen, alignOffset } = props;

  return (
    <TooltipProvider>
      <Tooltip open={open}>
        <TooltipTrigger
          onClick={onClickOpen}
          onPointerMove={(e) => e.preventDefault()}
          onPointerLeave={(e) => e.preventDefault()}
        >
          <HelpCircle className="h-4 w-4 opacity-50" />
        </TooltipTrigger>
        <TooltipContent className={cn("p-0", className)} side={position} align={align} alignOffset={alignOffset}>
          <div className="flex flex-row items-center">
            <div className="flex-grow">{title}</div>
            <button
              className="rounded-sm opacity-70 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring disabled:pointer-events-none"
              onClick={onClickClose}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
